//This file defines the Hangman class.  Each class instance holds
//all the data for the playing of one game.

class Hangman {
    //Instance constructor.
    constructor (word, remainingGuesses) {
        this.remainingGuesses = remainingGuesses;
        //This is "playing", "failed", "surrendered", or "finished".
        this.status = 'playing';
        //Instance variable to be array.
        this.word = word.toLowerCase().split('');
        this.guessedLetters = [];
    }

    //Function to surrender the game.
    surrender() {
        if (this.status === 'playing') {
            this.status = 'surrendered';
        }
    }

    //Function to change status from "playing" to either 
    //"failed" or "finished" when neccessary.
    updateStatus() {
        if (this.remainingGuesses === 0) {
            this.status = 'failed';
            return;
        }

        if (this.word.every((letter) =>
            this.guessedLetters.includes(letter) 
                || letter === ' ')) {
                this.status = 'finished';
        }
    }

    //Creates statusMessage property.
    get statusMessage() {
        if (this.status === 'surrendered') {
            return `The word was "${this.word.join('')}."`;
        } else if (this.status === 'failed') {
            return 'Nice Try. ' 
                + `The word was "${this.word.join('')}."`;
        } else if (this.status === 'finished') {
            return 'You guessed the word. Great work!';
        } else { //playing
            const plural = this.remainingGuesses == 1 ? '' : 'es';
            return `You have ${this.remainingGuesses} `
                + `guess${plural} left.`;
        }
    }

    //Creates puzzle property.
    get puzzle() {
        //New variable -- not this.puzzle
        let puzzle = '';
        for (let i = 0; i < this.word.length; i++) {
            //Keep a space if one is found.
            if (this.word[i] === ' ') {
                puzzle += ' ';
                continue;
            }

            //Append letter or asterick to guess.
            puzzle += !this.guessedLetters.includes(this.word[i]) 
                ? '*' : this.word[i];
        }

        return puzzle;
    }

    //Function triggered when the user makes a guess.
    makeGuess(guess) {
        //Make guess lower case.
        guess = guess.toLowerCase();

        //Do nothing if guess is a repeat or not a letter or the 
        //game is lost or won.
        const letters = /^[a-z]+$/;
       
        const isLetter = guess.match(letters);
      
        if (isLetter && !this.guessedLetters.includes(guess)
            && this.status === 'playing') {
            this.guessedLetters.push(guess);
            //Adjust guess count if guess was bad.
            if (!this.word.includes(guess)) {
                this.remainingGuesses--;
            }
            this.updateStatus();
        }
    }
}

//Export class as default.
export {Hangman as default}